/*!
=========================================================
* D1_01：受注管理
=========================================================
*/
import React from "react";

import {
  Row, Col,
  FormGroup,
  Button,
  Label,
  Input
} from "reactstrap";

import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';

//import ListBase from '../Base/ListBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.14
import DialogBase from '../Base/DialogBase';
import InputCheckBox from "../FormParts/InputCheckBox";
import InputText from '../FormParts/InputText';
import InputSelect from '../FormParts/InputSelect';
import InputNumber from '../FormParts/InputNumber';
import InputFile from '../FormParts/InputFile';
import InputRadio from '../FormParts/InputRadio';
import InputDatetime from '../FormParts/InputDatetime'
import Format from "../../common/Format";
import Definition from '../../common/Definition';
import OptionConvert from '../../common/OptionConvert';
import WithRole from '../FormParts/ButtonWithRole';

import {
  cst_non_taxable_flag,
  cst_tax_in_flag,
  cst_term_month_flag,
  cst_estimate_change_flag,
  ORDER_BOX_STATUS,
  cst_purchase_order_box_status,
  PURCHASE_ORDER_BOX_STATUS,
  ESTIMATE_STATUS
} from '../../variables/codes_map';
import { GetMessage, getErrorCodes } from '../../variables/message';
import format_url from '../../variables/format_url';
import GoogleDrive from "../../common/GoogleDrive";
import custom_report from "../../variables/custom_report"
import BadgeWithTooltip from '../FormParts/BadgeWithTooltip'
import MemoPopup from "../ViewParts/MemoPopup";
import AddMemoPopup from "../ViewParts/AddMemoPopup";
import Common from '../../common/Common';
import Validate from "../../common/Validate";
import AddMemoPopupInner from "../ViewParts/AddMemoPopupInner";

const moment = require("moment");

class List extends ListBase {
  default_column = [
    { Header: '見積ID', accessor: 'ESTIMATE__estimate_number', headerClassName: "text-center", className: "text-center align-text-top",width:180 ,defaultView:true, isSortDisabled : true},
    { Header: '顧客情報',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left align-text-top',width:250,minWidth:50, isSortDisabled : true},
    // { Header: '顧客情報（下請）',accessor: '___JOIN_subcontract_customer_information',headerClassName:'text-center',className:'text-left text-top',width:250,minWidth:50, isSortDisabled : true},
    { Header: '現場名/工事番号/現場住所', accessor: '___JOIN_project_information_estimate', headerClassName: "text-center",width:200, className: "text-left align-text-top" ,defaultView:true, isSortDisabled : true},
    // { Header: '現場住所',accessor: '___JOIN_project_addr',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50, isSortDisabled : true},
    { Header: '仕入先情報',accessor: '___JOIN_use_parking',headerClassName:'text-center',className:'text-left align-text-top',width:250,minWidth:50, isSortDisabled : true},
    { Header: '見積期間',accessor: '___JOIN_survey_available_date',headerClassName:'text-center',className:'text-left align-text-top',width:185,minWidth:50, isSortDisabled : true},
    { Header: '契約開始予定日', accessor: 'ESTIMATE__quote_available_start_date', headerClassName: "text-center", className: "text-left align-text-top" ,width:185,defaultView:true},
    // { Header: '発注書', accessor: 'action1', headerClassName: "text-center", className: "text-center" ,defaultView:true, sortable : false},
    // { Header: '失注処理', accessor: 'action3', headerClassName: "text-center", className: "text-center" ,defaultView:true, sortable : false},
    // { Header: 'キャンセル確認',accessor: 'actions_cancel_confirm',headerClassName:'text-center',className:'text-center',width:140,minWidth:50, sortable : false},
    // { Header: '最終更新情報', accessor: '___JOIN_estimate_update', headerClassName: "text-center", className: "text-left text-top" ,width:225,defaultView:true},
    // { Header: '顧客メモ',accessor: 'ESTIMATE__order_memo', headerClassName: "text-center", className: "text-left text-top",width:250,minWidth:50 ,defaultView:true},
    // { Header: '仕入先メモ',accessor: 'ESTIMATE__supplier_memo', headerClassName: "text-center", className: "text-left text-top",width:250,minWidth:50 ,defaultView:true},
    // { Header: '顧客への連絡事項',accessor: 'ESTIMATE__contact_memo', headerClassName:'text-center',className:'text-left text-top',width:250,minWidth:50, sortable : false},
    // { Header: '',accessor: 'TEMP__contact_memo',id:'TEMP__contact_memo', headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50, sortable : false, headerLabel: "更新ボタン"},
    // #1198 テスト用コード
    //{ Header: 'テスト',accessor: 'test',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50,add_flg:true},
  ];
  
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '発注書アップロード',
      search_url: '/api/order/unlimit', // #1168-2021.7.14
      base_search_url: '/api/order',
      header_md:'3',
      all_checked: true,

      column: this.default_column,
      // with_all_check: true,
      searchData:{
        values:{
          register_type: 0,
          box_status: String(this.props.box_status)
        },
        errors:{},
        requiredData:{}
      },
      valid: true,
      landmark_user:[],
      dialogData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      dialogUploadData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      dialogConfirmData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      dialogReturnEstimateData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      selectableUserList:[],
      auto_scroll:true,
      addMemoPopupData:{},
      customerList : [],
      customerBranchList : [],
    });

    const urlParams = new URLSearchParams(this.props.location.search)
    if(urlParams.has('estimate_number')) {
      const estimate_estimate_number = urlParams.get('estimate_number');
      this.state.estimate_estimate_number = estimate_estimate_number
      this.state.parking_parking_name = estimate_estimate_number
    }
    this.dialogUpload = React.createRef();
    this.dialog = React.createRef();
    this.dialogConfirm = React.createRef();
    this.uploadDialog = React.createRef()
    this.dialogCancelConfirm = React.createRef();
    this.dialogReturnEstimate = React.createRef();
    this.memoPopup = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
    this.getLastUpdaedUser = this.getLastUpdaedUser.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)
    this.validateCallbackForMemo = this.validateCallbackForMemo.bind(this)
    this.addMemoPopup = React.createRef();
  }
  
  getLastUpdaedUser(lastupdate_user_id){
    const user_list = this.state.landmark_user;
    const matchedUser = user_list.find((singleUser)=>singleUser.id===lastupdate_user_id)
    const lastupdate_user = matchedUser ? (
      {
        name:matchedUser.label,
        picture:matchedUser.picture,
        ulid:matchedUser.id,
        id:matchedUser.value
      }
    ):(
      {
        name:"",
        picture:"",
        ulid:"",
        id:""
      }
    )
    return lastupdate_user
  }
  validateCallbackForMemo(newData, estimates, key, name, type){
    this.setState({
      data : [
        ...this.state.data.slice(0, key),
        {
          ...this.state.data[key],
          [name] : {
            ...this.state.data[key][name],
            props : {
              ...this.state.data[key][name].props,
              rootData : newData
            }
          }
        },
        ...this.state.data.slice(key+1),
      ]
    })
    if(Object.keys(newData.errors).length > 0){
      return;
    }
    const originMemo = this.state.data[key][name].props.rootData.values[type];
    if ( originMemo == newData.values[type]
      || (originMemo == null && newData.values[type] == "")) {
      return;
    }

    const url = '/api/estimate/memo/'+estimates.ulid
    const params = {
      ...estimates,
      [type]:newData.values[type]
    }
    //console.log(params)
    Request.put(url, params, (res)=>{
      //console.log(res.Data)
      // this.search(); // メモ更新時は再検索しない
    })
  }

  dataMap(data) {
    console.log("*** data",data);
    return data.map((prop, key) => {
      const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons, prop)
      const lastupdate_user = this.getLastUpdaedUser(prop.lastupdate_user_id)
      const prop_tmp = {user_name:lastupdate_user.name, update_timestamp:prop.update_timestamp}

      let disp_status = "";
      // 見積ステータスが失注の場合のみ、表示を受注BOXステータスとは別にする
      if([ESTIMATE_STATUS.MANUAL_LOST_ORDER, ESTIMATE_STATUS.AUTO_LOST_ORDER].includes(prop.estimate_status)){
        disp_status = prop.estimate_cancel_check_flag === 0 ? "見積キャンセル" : "失注";
      }else{
        disp_status = Common.getValueFormDictArray(cst_purchase_order_box_status, prop.purchase_order_box_status);
      }
      const isAutoOrder = prop.auto_order_execution_flag == 1 && prop.auto_order_function_flag == 1

      const rowColor = isAutoOrder ? "bg-lyellow" : prop.register_type === 1 ? "bg-lblue" : "";

      return {
        id: key,
        rowColor: rowColor,
        // isBgLblue: prop.register_type === 1,
        ___JOIN_client_master: (
          <>
            <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />
            <div class="mt-2">	顧客情報（下請先）</div>
            <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information', prop)}} />
            <div class="bottom-box-1">
              <ButtonWithTooltipWithRole
                disabled={prop.estimate_status>5}
                button_id="BTN_D1_01_01970"
                onclick={() => { 
                  this.setState({
                    dialogConfirmData:{
                      values:prop,
                      errors:{},
                      requiredData:{}
                    }
                  }, ()=>{
                    this.dialogConfirm.current.show()
                  })
                } }
                size="sm"
                id="tmp"
                label="失注"
                message="失注を開始します。"
              />
              &nbsp;
              <Button 
                disabled={prop.customer_system_use_flag === 0 || prop.estimate_cancel_check_flag == 1} 
                size="sm" 
                onClick={()=>this.setCancelConfirmDialog(prop)}>
                  キャンセル確認
              </Button>
            </div>
          </>
        ),
        ESTIMATE__estimate_number: (
          <>
            <a href={GoogleDrive.getOpenUrl(prop.latest_pdf_survey_url)} target="_blank">{`${prop.register_type==1 ? "(*)":""}${prop.estimate_natural_id}`}</a>
            <p class="text-center" style={{marginTop:"5px"}}>{disp_status}</p>
            <div class="bottom-box-1">
              <ButtonWithTooltipWithRole
                disabled={prop.estimate_status>5}
                button_id="BTN_D1_01_01950"
                onclick={() => { 

                  // 工事番号が必須かチェック
                  const isRequiredClient = prop.construction_number_require_flag == 1 ? true : false;
                  const requiredAlert = isRequiredClient&&!prop.construction_number
                  if(requiredAlert){
                    // 工事番号が必須のメッセージを表示
                    this.props.alertModal.current.confirmCheck({
                      messageNo:2414,
                    },() => {
                      this.props.alertModal.current.toggleErrorModal();
                    }, false);
                    return;
                  }
                  // 一度「見積からの内容変更あり」で登録した場合、以降の「見積からの内容変更あり」をチェック有で固定する
                  prop = {...prop, initial_estimate_change_flag: prop.estimate_change_flag}
                  this.setState({
                    dialogUploadData:{
                      values:prop,
                      errors:{},
                      requiredData:{}
                    }
                  }, ()=>{
                    this.dialogUpload.current.show()
                  })
                } }
                size="sm"
                id="tmp"
                label="発注書"
                message="顧客からの発注書をアップロード"
              />
              {prop.latest_pdf_purchase_order_url && <>
                <br/>
                  <a 
                    onClick={() => {
                      // 顧客システム利用の場合は、発注書確認フラグを更新する。
                      if(prop.customer_system_use_flag === 1){
                        // すでに１の場合は更新しない
                        if(prop.purchase_order_check_flag !== 1){
                          Request.put('/api/order/checked/' + prop.ulid, {purchase_order_check_flag : 1}, res=>{
                            this.search();
                          },(err)=>{
                          })
                        }
                      }
                    }}
                    href={`/api/gcs_download/${prop.latest_pdf_purchase_order_url}?d=発注書_${moment().format("YYYYMMDDHHmmss")}&extension=true`} target="_blank">
                    発注書確認
                  </a>
              </>}
              </div>
          </>
        ),
        REQUEST__estimate_deadline: Format.format_date(prop.estimate_deadline)  ,
        ___JOIN_project_information_estimate:(
          <>
            <div style={{wordBreak: "break-all",maxHeight: "155px", overflow: "auto"}} dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_information_addr', prop)}} />
            <div class="bottom-box-1">
              <div class="mt-2">顧客メモ</div>
              <Input
                type={"textarea"}
                value={prop.order_memo || ""}
                disabled={false}
                onClick={() => {
                  this.setState({
                    addMemoPopupData : {
                      values : prop,
                      isOrderMemo: true,
                      label: "顧客メモ"
                    }
                  }, () => { 
                    this.addMemoPopup.current.show()
                  })
                }}
              />
            </div>
          </>
        ) ,
        ___JOIN_survey_available_date: (
          <>
            <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_survey_available_date', prop)}} />
            <div class="bottom-box-1" style={{display: 'none'}}>
              <Input
                type={"textarea"}
                value={prop.contact_memo}
                disabled={true}>
              </Input>
              <Button
                size="sm" 
                disabled={prop.customer_system_use_flag !== 1}
                onClick={() => {
                  this.setState({
                    memoPopupData : {
                      values : prop
                    }
                  }, () => { this.memoPopup.current.show() })
                  
                }}
                className="text-center"
              >
                顧客への連絡事項
              </Button>
            </div>
          </>
        ) ,
        ESTIMATE__quote_available_start_date : (
          <>
            {prop.estimate_change_flag == "1" ? Format.format_date(prop.order_start_date) : Format.format_date(prop.survey_available_start_date)}
            <div class="bottom-box-1">
              <div class="mt-2">最終更新者</div>
              <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_estimate_update', prop_tmp)}} />  
            </div>
          </>
        ),
        ___JOIN_use_parking: (
          <>
            <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_use_parking', prop)}} /><br /><br />
            <div class="bottom-box-1">
              <div class="mt-2">仕入先メモ</div>
              <Input
                type={"textarea"}
                value={prop.supplier_memo || ""}
                disabled={false}
                onClick={() => {
                  this.setState({
                    addMemoPopupData : {
                      values : prop,
                      isOrderMemo: false,
                      label: "仕入先メモ"
                    }
                  }, () => { 
                    this.addMemoPopup.current.show()
                  })
                }}
            />
            </div>
          </>
        )
      }
    });
  }

  //メモ更新API呼び出し
  updateEstimateMemo(data, isOrderMemo){
    console.log(data)
		const max_length_validate = Validate.length(data.add_memo, "", "text_ja_20000")
		if(!max_length_validate.valid){
      this.props.alertModal.current.showErrorModal({message:max_length_validate.message});
			return;
		}    
    const ulid = data.ulid
    const url = '/api/estimate/memo/'+ ulid
    const params = {
      add_memo: data.add_memo,
      isOrderMemo: isOrderMemo,
      update_timestamp: data.update_timestamp,
      login_user: localStorage.getItem("name")
    }
    Request.patch(url, params, (res)=>{
      // サブコンポーネントのエレメントを再取得し
      // 関数を実行させる。ここではデータを再取得させている
      this.search();
    })
  }

  updateMemo(data){
    // 無効な文字列チェック
		const max_length_validate = Validate.length(data.contact_memo, "", "text_ja_20000")
		if(!max_length_validate.valid){
      this.props.alertModal.current.showErrorModal({message:max_length_validate.message});
			return;
		}

    const url = '/api/request/memo/'+data.ulid
    const params = {
      ...data,
    }
    Request.put(url, params, (res)=>{
      this.search();
    })
  }

  async sendSupplierNgMail(prop){
    const {
      customer_branch_natural_id,
      customer_user_natural_id,
      project_natural_id,
      request_natural_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user_natural_id,
      request_user_branch_natural_id:user_branch_natural_id,
      send_destination_type,
      want_guide_type,
      want_guide_type_subcontract,
    } = prop;

    Request.setProgress(10)
    const estimateCommonParams = await Request.getEstimateCommon({
      customer_branch_natural_id,
      customer_user_natural_id,
      project_natural_id,
      request_natural_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user_natural_id,
      estimateObject: prop,
      user_branch_natural_id
    })

    Request.setProgress(20)
    const mailData = await new Promise((resolve, reject)=>{
      const mailUrl = '/api/pout/D10_MAIL'
      const mailParams = {
        format_url:GoogleDrive.getFormatUrl(format_url.D10_MAIL),
        send_destination_type:send_destination_type,
        want_guide_type:want_guide_type,
        want_guide_type_subcontract:want_guide_type_subcontract,
        ...estimateCommonParams
      }
      Request.post(mailUrl, mailParams, res=>{
        resolve(res)
      }, err=>{
        reject(err)
      })
    })
    Request.setProgress(80)
    const sendMailUrl = '/api/send/MAIL';
    Request.post(sendMailUrl, mailData.Data, res=>{
      window.open(`https://mail.google.com/mail/u/0/#drafts`);
    }, err=>{}, () => {
      Request.setProgress(0)
    })
  }

  setCancelConfirmDialog(estimate){
    this.setState({
      dialogCancelConfirmData:{
        ...this.state.dialogCancelConfirmData,
        values:estimate,
      }
    }, () => { this.dialogCancelConfirm.current.show() })
  }

  setReturnEstimateDialog(estimate){
    this.setState({
      dialogReturnEstimateData:{
        ...this.state.dialogReturnEstimateData,
        values:estimate,
      }
    }, () => { this.dialogReturnEstimate.current.show() })
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list = OptionConvert.options(res.Data)
      const selectableUserList = OptionConvert.optionsById(res.Data)
      this.setState({
        landmark_user:user_list,
        selectableUserList
      }, () => {
        this.search(false);
      });
    })

    // ランドマーク支店の一覧取得
    Request.get("/api/landmark/user_branch",{}, res => {
      const user_branch_list = res.Data.map((prop,key)=>{
        return {
            value:prop.user_branch_natural_id,
            label:prop.user_branch_name,
        }
      })
      this.setState({landmark_user_branch:user_branch_list});
    })
    // 顧客会社名のリスト取得
    Request.get("/api/customer",{without_limit:true}, res => {
			const customerList = res.Data.map(element=>{
			  return {
          value:element.ulid,
          label:element.customer_name
			  }
			})
			this.setState({customerList});
		})
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]

        if(key == "search_estimate_cancel_check"){
          if(values[key] == 1){
            acc['estimate_statuses'] = [6,7]
            acc['estimate_cancel_check_flag'] = 0
          } else {
            acc['estimate_statuses'] = undefined
            acc['estimate_cancel_check_flag'] = undefined
          }
        }
      }
      return acc
    },{})
  }

  search(refreshTaskFlag = true) {
//    console.log("estimate >> list > search");

    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
  /* #1168-2021.9.14 limit offsetの追加 */
  this.search_count();
  var search_param = this.search_params();
    search_param["pager_index"] = "0";
    search_param["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      search_param
      , res => {
      
        this.setState({
          paging: {
            "index": parseInt(search_param["pager_index"]),
            "limit": parseInt(search_param["pager_limit"])
          },  
          data: this.dataMap(res.Data)
        });
    })
    // 見積キャンセル件数取得
    const estimateCancelParams = {
      data_count : 1,
      estimate_statuses : [6,7],
      estimate_cancel_check_flag : 0,
      box_status: this.props.box_status
    }
    Request.get(this.state.search_url, estimateCancelParams, res => {
      this.setState({
          custCancelCount : res.Data || 0
      });
    })

    Request.get(this.state.search_url, 
      {latest_pdf_purchase_order_url_upload_flag:"1", data_count : 1, box_status: this.props.box_status},
      res => {
        this.setState({
          latest_pdf_purchase_order_url_upload_count: res.Data || 0
        });
      }
    )
    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }
  /* #1168-2021.9.14 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
//        console.log(res.data);
        this.setState({data_count: res.Data});
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  async validateCallback(newData, callback=()=>{}){
    if(newData.values.customer_name != undefined || newData.values.customer_ulid != undefined){
      // 顧客会社名
			const customerParam = (this.state.customerList.findIndex(customer=>customer.value==newData.values.customer_ulid)>-1)
			? {
			  customer_ulid: newData.values.customer_ulid,
			  customer_name: undefined
			} : {
			  customer_ulid:undefined,
			  customer_name: (newData.values.customer_ulid != undefined)?newData.values.customer_ulid:newData.values.customer_name
			}
      
      // 顧客支店名リスト（詳細検索：顧客会社名でリスト選択時に顧客支店名のリスト取得）
			const customerBranchList = this.state.searchData.values.customer_ulid!=customerParam.customer_ulid
			? (customerParam.customer_ulid
			  ? await new Promise(resolve=>{
				Request.get("/api/customer/branch",{
				  customer_ulid:customerParam.customer_ulid,
				  customer_branch_delete_flag : 1
				}, res => {
				  resolve(res.Data.map(element=>{
					return {
					  value:element.ulid,
					  label:element.customer_branch_name
					}
				  })) 
				})
			  })
			  : [])
			: this.state.customerBranchList
			const customerBranchParam = this.state.searchData.values.customer_ulid==customerParam.customer_ulid
			? (customerBranchList.findIndex(customer=>customer.value==newData.values.customer_branch_ulid)>-1)
			  ? {
				customer_branch_ulid: newData.values.customer_branch_ulid,
				customer_branch_name: undefined
			  }
			  : {
				customer_branch_ulid: undefined,
				customer_branch_name: (newData.values.customer_branch_ulid != undefined)? newData.values.customer_branch_ulid:newData.values.customer_branch_name
			  }
			: {
			  customer_branch_ulid: undefined,
			  customer_branch_name: undefined
			}

      this.setState({
			  searchData:{
				...this.state.searchData,
				...newData,
				values:{
					...this.state.searchData.values,
					...newData.values,
					...customerParam,
					...customerBranchParam
				}
			  },
			  customerBranchList
			}, ()=>callback())
    }else{
			this.setState({
				searchData:{
				  ...this.state.searchData,
				  ...newData,
				  values:{
					  ...this.state.searchData.values,
					  ...newData.values,
				  }
				},
			  }, ()=>callback())
		}
  }

  add_field_cols() {
    const {
      custCancelCount,
      latest_pdf_purchase_order_url_upload_count,
    } = this.state
    return (
      <>
        <Col md="5"></Col>
        <Col md="4">
          <div style={{paddingTop: "35px"}}>見積キャンセル件数：{custCancelCount}</div>
          <div>発注書アップロード済み件数：{latest_pdf_purchase_order_url_upload_count}</div>
        </Col>
      </>
    );
  }

  search_field_cols() {
    return (
      <>
        <Col md="3">
          <FormGroup>
            <InputSelect
              label="ランドマーク支店"
              name="USER_BRANCH__user_branch_natural_id"
              labelOn={true} 
              validateCallback={this.validateCallback} 
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              options={this.state.landmark_user_branch}
              rootData={this.state.searchData}
              validateType={'search'}
              isSearchable={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputSelect
              label="調査担当者"
              name="REQUEST__onsite_survey_account"
              labelOn={true}
              validateCallback={this.validateCallback}
              options={this.state.selectableUserList}
              rootData={this.state.searchData}
              validateType={'search'}
              isSearchable={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='見積ID'
              name='ESTIMATE__estimate_natural_id'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='顧客担当者TEL'
              name='CUSTOMER_USER__customer_user_tel'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        {/* <Col md="3">
        </Col> */}
      </>
    );
  }

  detail_search_field_cols(){
    return (
      <>
        <Col md="12">
          <FormGroup>
            <InputCheckBox
              label='失注したデータを表示する'
              name='ESTIMATE__estimate_status'
              labelOn={false}
              checkedValue={1}
              uncheckedValue={0}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
            />
            <InputCheckBox
              label='見積キャンセル'
              name='NODB__search_estimate_cancel_check'
              labelOn={false}
              checkedValue={1}
              uncheckedValue={0}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
            />
            <InputCheckBox
              label='発注書アップロード済みかつ未受注'
              name='ESTIMATE__latest_pdf_purchase_order_url_upload_flag'
              labelOn={false}
              checkedValue={1}
              uncheckedValue={0}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
            />
            <InputCheckBox
              label='顧客向けシステムで登録されたデータ'
              name='PROJECT__register_type'
              labelOn={false}
              validateCallback={this.validateCallback}
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputSelect
              label="顧客会社名"
              labelOn={true}
              name="CUSTOMER__customer_ulid"
              options={this.state.customerList}
              validateCallback={this.validateCallback} 
              validateType='search'
              isSearchable={true}
              isCreatable={true}
              rootData={this.state.searchData}
              searchStartLength={2}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputSelect
              label="顧客支店名"
              labelOn={true}
              key={`customer_branch_${this.state.searchData.values.customer_customer_ulid}`}
              name="CUSTOMER_BRANCH__customer_branch_ulid"
              options={this.state.customerBranchList}
              validateCallback={this.validateCallback} 
              validateType='search'
              rootData={this.state.searchData}
              isSearchable={true}
              isCreatable={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='工事番号'
              name='PROJECT__construction_number'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3"></Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='現場名'
              name='PROJECT__site_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='現場所在地'
              name='PROJECT__site_location'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='仕入先名'
              name='ESTIMATE__supplier_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='仕入先TEL'
              name='ESTIMATE__supplier_tel'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='駐車場名'
              name='ESTIMATE__survey_parking_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='駐車場所在地（ 住所の方 ）'
              name='ESTIMATE__survey_parking_location'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='依頼受付日（FROM）'
              name='ESTIMATE__request_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='依頼受付日（TO）'
              name='ESTIMATE__request_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出期限（FROM）'
              name='REQUEST__estimate_deadline_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出期限（TO）'
              name='REQUEST__estimate_deadline_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出日（FROM）'
              name='ESTIMATE__estimate_filling_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出日（TO）'
              name='ESTIMATE__estimate_filling_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
      </>
    );
  }

  checkbox_field_cols() {
    return (
      <>
      </>
    );
  }

  dialog_defines() {
    // const isUnderAdjustmentButton = this.state.dialogUploadData.values.purchase_order_box_status === PURCHASE_ORDER_BOX_STATUS.WAITING_DOCUMENTS
    // 2079 調整中BOX廃止
    const isUnderAdjustmentButton = false;
    const isNotYetButton = this.state.dialogUploadData.values.purchase_order_box_status === PURCHASE_ORDER_BOX_STATUS.COMPLETE ? false : true
    return (
      <>
        <Dialog 
          ref={this.dialog} 
          {...this.props}
          data={this.state.dialogData}
          positive={true}
          refreshCallback={this.search}
        />
        <DialogConfirm 
          ref={this.dialogConfirm} 
          {...this.props}
          data={this.state.dialogConfirmData}
          positive={true}
          refreshCallback={this.search}
          isLostOrder={true}
          default_footer={true}
        />
        <DialogUpload ref={this.dialogUpload} 
          {...this.props}
          data={this.state.dialogUploadData}
          positive={isNotYetButton}
          positive_label={isNotYetButton ? "受注管理.未着手BOXへ" : "" }
          newtral= {isUnderAdjustmentButton}
          newtral_label={isUnderAdjustmentButton ? "提案.調整中BOXへ" : ""}
          newtral_color={isUnderAdjustmentButton ? "info" : ""}
          newtral_right_alignment={isUnderAdjustmentButton}
          negative_label="キャンセル"
          refreshCallback={this.search}
          landmark_user={this.state.selectableUserList}
          />
        <DialogCalcelConfirm
          ref={this.dialogCancelConfirm}
          data={this.state.dialogCancelConfirmData}
          positive={true}
          refreshCallback={this.search}
        />
        <DialogReturnEstimate
          ref={this.dialogReturnEstimate}
          data={this.state.dialogReturnEstimateData}
          positive={true}
          refreshCallback={this.search}
        />
        <MemoPopup 
          ref={this.memoPopup} 
          data={this.state.memoPopupData} 
          positive={true}
          updateMemo = {(data) => this.updateMemo(data)}
          {...this.props}
        />
        <AddMemoPopup 
          ref={this.addMemoPopup} 
          data={this.state.addMemoPopupData} 
          positive={true}
          updateMemo = {(data, isOrderMemo) => this.updateEstimateMemo(data, isOrderMemo)}
          {...this.props}
        />
      </>
    );
  }
}

class DialogUpload extends DialogBase {
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: '発注書アップロード',
      data: this.props.data,
      // disablePositive:false
      cuFiles:[],
    });
    this.validateCallback = this.validateCallback.bind(this)
    // this.validateEstimateChangeCallback = this.validateEstimateChangeCallback.bind(this)
  }

  async componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      const isRequiredClient = this.props.data.values.construction_number_require_flag == 1 ? true : false;
      const requiredAlert = isRequiredClient&&!this.props.data.values.construction_number

      let order_schedule_date;
      if(this.props.data.values.order_schedule_date){
        order_schedule_date = this.props.data.values.order_schedule_date;
      } else {
        // ｎ日後の営業日取得
        order_schedule_date = await new Promise(resolve => {
          Request.get('/api/workday', { add_day : 14 }, res => {
            resolve(moment(res.Data).format("YYYY-MM-DDT00:00:00"))
          })
        })
      }

      const estimate_id = this.props.data.values.id;
      const cuFiles = await new Promise(resolve => {
        Request.get('/api/cufile', { ref_id : estimate_id, file_type : 4, file_detail_type : 401, create_system_type : 2}, res => {
          resolve(res.Data)
        })
      })
      this.setState({
        cuFiles : cuFiles
      })

      // const cuEstimate = await new Promise(resolve => {
      //   Request.get('/api/cuestimate', { core_id : estimate_id}, res => {
      //     resolve(res.Data)
      //   })
      // })

      const {
        latest_pdf_purchase_order_url,
        quote_available_start_date,
        survey_available_start_date,
        estimate_change_flag,
      } = this.props.data.values;
      // const update_check = this.props.data.values.update_timestamp < cuEstimate.update_date
      // const estimate_change_flag = update_check ? cuEstimate.estimate_change_flag : this.props.data.values.estimate_change_flag
      // let order_start_date = update_check ? cuEstimate.order_start_date : this.props.data.values.order_start_date
      // let order_end_date = update_check ? cuEstimate.order_end_date : this.props.data.values.order_end_date
      // let order_capacity_qty = update_check ? cuEstimate.order_capacity_qty : this.props.data.values.order_capacity_qty

      // const estimate_change_flag = this.props.data.values.estimate_change_flag
      let order_start_date = this.props.data.values.order_start_date
      let order_end_date = this.props.data.values.order_end_date
      let order_capacity_qty = this.props.data.values.order_capacity_qty

      order_start_date = order_start_date == null ? "" : order_start_date
      order_end_date = order_end_date == null ? "" : order_end_date

      this.setState({
        data: {
          values:{
            ...this.props.data.values,
            order_schedule_date : order_schedule_date,
            send_upload_notification : 0,
            latest_pdf_purchase_order_url: latest_pdf_purchase_order_url ? latest_pdf_purchase_order_url : "",
            // quote_available_start_date : quote_available_start_date ? quote_available_start_date : survey_available_start_date
            // latest_pdf_purchase_order_url : cuFiles.length > 0 ? cuFiles[0].file_path : null
            estimate_change_flag: estimate_change_flag,
            order_start_date:order_start_date,
            order_end_date:order_end_date,
            order_capacity_qty:order_capacity_qty,
            // order_contact_memo: cuEstimate.order_memo
            contract_user_id:this.props.data.values.contract_user_id? this.props.data.values.contract_user_id: null,
          },
          errors:{
            ...((this.props.data.values.latest_pdf_purchase_order_url || cuFiles.length > 0)?{latest_pdf_purchase_order_url:null}:{latest_pdf_purchase_order_url:[GetMessage(2024)]}),
            ...((estimate_change_flag == "0" || order_start_date != null ) ?{order_start_date:null}:{order_start_date:[GetMessage(2024)]}),
            ...((estimate_change_flag == "0" || order_end_date != null ) ?{order_end_date:null}:{order_end_date:[GetMessage(2024)]}),
            ...((estimate_change_flag == "0" || order_capacity_qty != null )?{order_capacity_qty:null}:{order_capacity_qty:[GetMessage(2024)]})
      
          },
          requiredData:{
            order_schedule_date: [GetMessage(2024)],
            latest_pdf_purchase_order_url: [GetMessage(2024)],
            order_start_date: [GetMessage(2024)],
            order_end_date: [GetMessage(2024)],
            order_capacity_qty: [GetMessage(2024)],
          }
        },
        newtral:this.props.newtral,
        newtral_label:this.props.newtral_label,
        newtral_color:this.props.newtral_color,
        newtral_right_alignment:this.props.newtral_right_alignment,
        positive:this.props.positive,
        positive_label:this.props.positive_label
        // disablePositive:Boolean(requiredAlert)
      },()=>{}
      // ()=>console.log(this.state.data.values)
      )
    }
  }

  // validateCallback(newData, callback=()=>{}){
  //   this.setState({
  //     data:{
  //       ...this.state.data,
  //       ...newData
  //     }
  //   }, ()=>callback())
  // }

  validateCallback(newData, callback=()=>{}){

    let order_start_date = "";
    let order_end_date = "";
    let order_capacity_qty = "";
    let errors = newData.errors

    if(newData.values.estimate_change_flag == "1"){
      order_start_date = newData.values.order_start_date == "" ? null : newData.values.order_start_date;
      order_end_date = newData.values.order_end_date == "" ? null : newData.values.order_end_date;
      order_capacity_qty = newData.values.order_capacity_qty == "" ? null : newData.values.order_capacity_qty;

      
      if(newData.values.estimate_change_flag != this.state.data.values.estimate_change_flag){
        errors.order_start_date = [GetMessage(2024)] ;
        errors.order_end_date =[GetMessage(2024)];
        errors.order_capacity_qty = [GetMessage(2024)];
      } else {
        errors.order_start_date = order_start_date == null ? [GetMessage(2024)] : JSON.stringify(errors.order_start_date) != JSON.stringify([GetMessage(2024)]) && errors.order_start_date != null ? errors.order_start_date : null;
        errors.order_end_date = order_end_date == null ? [GetMessage(2024)] : JSON.stringify(errors.order_end_date) != JSON.stringify([GetMessage(2024)]) && errors.order_end_date != null ? errors.order_end_date : null;
        errors.order_capacity_qty = order_capacity_qty == null ? [GetMessage(2024)] : JSON.stringify(errors.order_capacity_qty) != JSON.stringify([GetMessage(2024)]) && errors.order_capacity_qty != null ? errors.order_capacity_qty : null;
      }

      if(order_start_date && order_end_date){
        console.log(errors)
        if(this.alertDateCheck(newData.values,newData)){
          errors.order_start_date = null
          errors.order_end_date = null
          this.setState({
            data:{
              ...this.state.data,
              ...newData,
              errors:errors
            },
          }, ()=>{
            callback();
          })
        }
      }else{
  
        this.setState({
          data:{
            ...this.state.data,
            ...newData,
            errors:errors
          }
        }, ()=>callback())  
      }

    }else{
      let tmpData = newData
      // tmpData.values.order_start_date = ""
      // tmpData.values.order_end_date = ""
      // tmpData.values.order_capacity_qty = null
      this.setState({
        data:{
          ...this.state.data,
          ...tmpData,
          errors:{
            ...newData.errors,
            order_start_date:null,
            order_end_date:null,
            order_capacity_qty:null,
          }
        }
      }, ()=>callback())        
    }
  }  
  alertDateCheck({
    order_start_date,
    order_end_date
  },newData){
    const {
      order_start_date:prev_order_start_date,
    } = this.state.data.values
    if(order_start_date && order_end_date){
      if(moment(order_start_date) > moment(order_end_date)){

        this.setState({
          data:{
            ...this.state.data,
            ...newData,
            errors:{
              ...newData.errors,
              ...{[(prev_order_start_date === order_start_date ? 'order_end_date' : 'order_start_date')]:[GetMessage(2462)]},
            }
          }
        })
        return false
      }
    }
    return true
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickNegative() {
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.setState({})
    this.toggleModal();
  }

  handleClickNewtral() {
    // 発注書BOXステータスの値を1:調整中に変更
    const purchase_order_box_status = PURCHASE_ORDER_BOX_STATUS.UNDER_ADJUSTMENT
    this.fileUpload(purchase_order_box_status)
    document.body.style.overflow = "auto";
  }

  handleClickPositive(){
    // 依頼BOXステータスの値を7:完了に変更
    const purchase_order_box_status = PURCHASE_ORDER_BOX_STATUS.COMPLETE
    this.fileUpload(purchase_order_box_status)
    document.body.style.overflow = "auto";
  }

  fileUpload(purchase_order_box_status) {
    if(!this.validate()){
      return;
    }
    Request.setProgress(10)
    const sendUploadNotification = Boolean(this.state.data.values.send_upload_notification)
    const wasFileUploaded = this.state.data.values["latest_pdf_purchase_order_url_base64"] !== undefined
    // BOXへをクリックした場合のみ受注BOXステータスの値を0:未着手に変更
    const uploadParams = {
      ...this.state.data.values,
      purchase_order_check_flag : 1,
      order_box_status : purchase_order_box_status === PURCHASE_ORDER_BOX_STATUS.COMPLETE ? ORDER_BOX_STATUS.NOT_YET : undefined,
      purchase_order_box_status : purchase_order_box_status,
      login_user: localStorage.getItem("name")
    }
    Request.put('/api/order/file_upload/' + this.state.data.values.ulid, uploadParams, async res=>{
      if(res.Code === 200){
        if(sendUploadNotification){
          await this.sendUploadNotification()
        }

        Request.setProgress(0)
        this.completedModal()
      }
    },(err)=>{
      Request.setProgress(0)
    })
  }

  async sendUploadNotification(){
    const {
      want_guide_type,
      customer_branch_natural_id,
      customer_user_natural_id,
      project_natural_id,
      request_natural_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user_natural_id,
      want_guide_type_subcontract,
      request_user_branch_natural_id:user_branch_natural_id,
      customer_system_use_flag
    } = this.state.data.values

    const estimateCommonParams = await Request.getEstimateCommon({
        customer_branch_natural_id,
        customer_user_natural_id,
        project_natural_id,
        request_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        estimateObject: this.state.data.values,
        user_branch_natural_id
    })
    const {
      CUSTOMER_USER__customer_reminder_sms_flag_code,
      CUSTOMER_USER__customer_user_tel
    } = estimateCommonParams.object_customer
    const {
      CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
      CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel_subcontract
    } = estimateCommonParams.object_customer_subcontract
    const {
      PROJECT__send_destination_type,
      PROJECT__site_customer_user_tel
    } = estimateCommonParams.object_project
    Request.setProgress(60)
    // D01_MAIL_発注書受領 通知
    let d01Mail = (
      ((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0"))
      ||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))
    ) 
    ? new Promise((resolve, reject)=>{
      const mailUrl = '/api/pout/D01_MAIL'
      const mailParams = {
        format_url:GoogleDrive.getFormatUrl(format_url.D01_MAIL),
        send_destination_type:PROJECT__send_destination_type,
        want_guide_type:want_guide_type,
        want_guide_type_subcontract:want_guide_type_subcontract,
        ...estimateCommonParams
      }
      Request.post(mailUrl, mailParams, res=>{
        resolve(res)
      }, err=>{
        reject(err)
      })
    })
    :{Code:200}

    // D01_FAX_発注書受領 通知
    let d01Fax = (
      ((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="2"||want_guide_type=="0"))
      ||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0"))
    ) 
    ? new Promise((resolve, reject)=>{
      const faxUrl = '/api/pout/D01_FAX'
      const faxParams = {
        format_url:GoogleDrive.getFormatUrl(format_url.D01_FAX),
        // 顧客システム利用の場合は元請けのFAXは作成しない
        send_destination_type : PROJECT__send_destination_type,
        want_guide_type:want_guide_type,
        want_guide_type_subcontract:want_guide_type_subcontract,        
        ...estimateCommonParams
      }
      Request.post(faxUrl, faxParams, res=>{
        resolve(res)
      }, err=>{
        reject(err)
      })
    })
    :{Code:200}

    // D01_SMS_発注書受領 通知
    let d01Sms = (
      ( (PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && CUSTOMER_USER__customer_user_tel) )
      || ((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract=="1" && CUSTOMER_USER__customer_user_tel_subcontract)
      || PROJECT__site_customer_user_tel)
    )
    ? new Promise((resolve, reject)=>{
      const smsUrl = '/api/pout/D01_SMS'
      const smsParams = {
        format_url:GoogleDrive.getFormatUrl(format_url.D01_SMS),
        send_destination_type:PROJECT__send_destination_type,
        want_guide_type:want_guide_type,
        want_guide_type_subcontract:want_guide_type_subcontract,        
        ...estimateCommonParams
      }
      Request.post(smsUrl, smsParams, res=>{
        resolve(res)
      }, err=>{
        reject(err)
      })
    })
    :{Code:200}

    const d01Results = await Promise.all([d01Mail, d01Fax, d01Sms]).then(r=>r).catch(()=>{
      Request.setProgress(0)  
      return 
    })

    d01Mail = d01Results && d01Results[0]
    d01Fax = d01Results && d01Results[1]
    d01Sms = d01Results && d01Results[2]

    Request.setProgress(60)
    if (d01Mail.Code==200 && d01Fax.Code==200 && d01Sms.Code==200){
      let messageNo = [2417]
      const sendMailUrl = '/api/send/MAIL'
      d01Mail.Data&&d01Mail.Data.forEach((mailData)=>{
        Request.post(sendMailUrl, mailData, res=>{
        }, err=>{
            
        },undefined, true, false)
      })
        
      // 顧客システム利用の場合は送付先が下請け、両方の場合のみ送付状を送信する
      const sendFaxUrl = '/api/send/FAX'
      d01Fax.Data&&d01Fax.Data.forEach((faxData)=>{
        Request.post(sendFaxUrl, faxData, res=>{
          
        }, err=>{
            
        },undefined, true, false)
      })
      // 2520 対応
      const resultSms = await new Promise((resolve, reject) => {
        if (d01Sms.Data == undefined) {
          resolve({Code: 200})
        }        
        const sendSmsUrl = '/api/send/SMS'
        d01Sms.Data&&d01Sms.Data.forEach((smsData)=>{
          if (smsData.site_flag == true) {
            if (smsData.site_error == true) {
              const registerType = Number(estimateCommonParams.object_project.PROJECT__register_type);
              // console.log(smsData)
              if (registerType === 0) {
                resolve({Code: 200})
              }else{
                resolve({Code: 2631})
              }
            }else{
              Request.post(sendSmsUrl, smsData, res=>{
                if (res.Data && res.Data.sms_status == 'accepted'){
                  resolve({Code: 200})
                }else{
                  resolve({Code: 2631, data: res.Data})
                }
              }, err=>{
                resolve({Code: 2631, data: err})
              },undefined, true, false)
            }
          } else {
            Request.post(sendSmsUrl, smsData, res => {}, err => {}, undefined, true, false)
          }
        })
      })
      Request.setProgress(90)

      document.body.style.overflow = "auto";

      if(((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0")) 
        ||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))){
        window.open(`https://mail.google.com/mail/u/0/#drafts`);
      }
      Request.setProgress(0)
      if (resultSms.Code == 200) {
        this.props.alertModal.current.confirmCheck({
          title: "処理完了",
          messageNo: [2417],
          closeBtn: false
        }, ()=>{
          this.props.refreshCallback()
          this.toggleModal();
        }, false)
      } else {
        console.log(resultSms);
        let title = "エラー"
        let message = GetMessage(2631)
        if (resultSms.data && resultSms.data.sms != "") {
          message = message + "<br />\n" + resultSms.data.sms
        }
        this.props.alertModal.current.confirmCheck({
          title: title,
          message: message ,
          closeBtn: false
        }, () => {
          this.props.refreshCallback()
          this.toggleModal();          
        }, false)
      }
    


    }else{
      Request.setProgress(0)
    }

  }

  completedModal(callback){
    this.props.alertModal.current.confirmCheck({
      title: "処理完了",
      messageNo: [2417],
      closeBtn: false
    }, ()=>{
      this.props.refreshCallback()
      this.toggleModal();
    }, false)
  }

  handleCheckboxChange=()=>{
    
    const newValue = !Boolean(this.state.data.values.purchase_order_check_flag);

    const params = {
      purchase_order_check_flag:newValue
    }

    Request.put('/api/order/checked/' + this.state.data.values.ulid, params, res=>{

      this.setState({
        data:{
          ...this.state.data,
          values : {
            ...this.state.data.values,
            update_timestamp : res.Data.update_timestamp,
            purchase_order_check_flag : newValue
          }
        }
      })

    },(err)=>{
      console.log(err)
    })

  }

  bodyContent() {
    const displayCheckbox = (index) => index === 0 ? "" : "d-none";
    const isChecked = Boolean(this.state.data.values.purchase_order_check_flag);

//    console.log(this.state.data);
    return (
      <>
        <InputFile 
          label="発注書"
          name="ESTIMATE__latest_pdf_purchase_order_url"
          copy={false}
          showLink={true}
          validateCallback={this.validateCallback} 
          rootData={this.state.data} 
          disabled={this.state.cuFiles.length > 0}
          filename={`発注書_${moment().format("YYYYMMDDHHmmss")}&extension=true`}
          />

        {this.state.cuFiles.length > 0 &&
          <>
            <Row>
              <Col>
                顧客システムファイル
              </Col>
            </Row>
            {this.state.cuFiles.map((file, index) => (
              <Row key={index}>
                <Col>
                  <a href={`/api/gcs_download/${file.file_path}?d=${file.file_name}`} target="_blank">
                      {file.file_name}
                  </a>
                </Col>
                <Col className={displayCheckbox(index)} >
                 <Label >
                 <Input type="checkbox" defaultChecked={isChecked} onChange={this.handleCheckboxChange} />
                    確認済み
                  </Label>
                </Col>
              </Row>
            ))}
            <br/>
          </>
        }
        <Row>
          <Col md="12">
            <InputDatetime
              label='受注予定日'
              name='ESTIMATE__order_schedule_date'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.data}
              validateType="regist"
            />
          </Col>
        </Row>
          <Col md="12" style={{padding:'5px 0 0', marginTop:"10px"}}>
          <InputCheckBox
            label='見積からの内容変更あり'
            name='ESTIMATE__estimate_change_flag'
            labelOn={false}
            validateCallback={this.validateCallback}
            rootData={this.state.data}
            checkedValue={1}
            uncheckedValue={0}
            disabled={this.state.data.values.initial_estimate_change_flag}
          />
        </Col>        
        <Row>
          <Col md="4">
          契約開始日:{Format.format_date_en(this.state.data.values.survey_available_start_date)}
          <InputDatetime
            label='契約開始日'
            name='ESTIMATE__order_start_date'
            labelOn={false}
            validateCallback={this.validateCallback}
            rootData={this.state.data}
            disabled={this.state.data.values.estimate_change_flag == "0" ? true : false}
            validateType="regist"
          />
          </Col>
          <Col md="4">
          契約終了日:{Format.format_date_en(this.state.data.values.survey_available_end_date)}
          <InputDatetime
            label='契約終了日'
            name='ESTIMATE__order_end_date'
            labelOn={false}
            validateCallback={this.validateCallback}
            rootData={this.state.data}
            disabled={this.state.data.values.estimate_change_flag == "0" ? true : false}
            validateType="regist"
          />
          </Col>
          <Col md="4">
          台数:{this.state.data.values.survey_capacity_qty}台
          <InputNumber
            unit='台'
            label='台数'
            name='ESTIMATE__order_capacity_qty'
            labelOn={false}
            validateCallback={this.validateCallback}
            rootData={this.state.data}
            disabled={this.state.data.values.estimate_change_flag == "0" ? true : false}
            validateType="regist"
          />
          </Col>
        </Row>
        <Col md="12" style={{padding:'5px 0 0'}}>
          <InputCheckBox
            label='延長不可'
            name='ESTIMATE__cannot_extention_flag'
            labelOn={false}
            validateCallback={this.validateCallback}
            rootData={this.state.data}
            checkedValue={1}
            uncheckedValue={0}
          />
        </Col>
        <Row>
          <Col md="12">
          <InputText multiline={true}
            labelOn={true}
            label='顧客からの連絡事項'
            name='ESTIMATE__order_contact_memo'
            validateCallback={this.validateCallback} 
            rootData={this.state.data}
            validateType='regist'
            disabled={true}
            placeholder=" "
          />
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <InputCheckBox
              label='発注書受領通知を送る'
              name='NODB__send_upload_notification'
              labelOn={false}
              checkedValue={1}
              uncheckedValue={0}
              validateCallback={this.validateCallback}
              rootData={this.state.data}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export class Dialog extends DialogBase {
  constructor(props) {
    super(props);
    const now = new Date();
    const buf = moment(now);
    this.defaultData = buf.format("YYYY-MM-DD")
    Object.assign(this.state, {
      title: '以下の見積を受注します',
      data:{
        ...this.props.data,
        values:{
          ...this.props.data.values,
          quote_available_start_date:this.defaultData,
          quote_available_end_date:this.defaultData,
          quote_term_month_flag:this.props.data.values.quote_term_month_flag == undefined ? this.props.data.values.survey_term_month_flag : this.props.data.values.quote_term_month_flag
        },
        errors:{}
      },
      cuEstimate :{
        values:{},
        errors:{},
        requiredData:{},
        check:false,  
      },
    });
    this.validateCallback = this.validateCallback.bind(this)
    this.getCountsFromDuration = this.getCountsFromDuration.bind(this)
    this.createCustomEstimateDetails = this.createCustomEstimateDetails.bind(this)
    this.validate = this.validate.bind(this)
    
  }

  async componentDidUpdate(prevProps, prevState){

    if(prevProps.data!=this.props.data){

      const estimate_id = this.props.data.values.id;
      // let cuEstimate;
      // if(this.state.cuEstimate.values.estimate_natural_id != this.props.data.values.estimate_natural_id){
      //   cuEstimate = await new Promise(resolve => {
      //     Request.get('/api/cuestimate', { core_id : estimate_id}, res => {
      //       resolve(res.Data)
      //     })
      //   })
  
      // }

      const {
        request_type,
        survey_tax_in_flag,
        quote_available_start_date,
        survey_available_start_date
      } = this.props.data.values

      // const {
      //   order_start_date : order_start_date_custorder,
      //   order_end_date : order_end_date_custorder,
      //   order_capacity_qty : order_capacity_qty_custorder,
      //   estimate_change_flag : estimate_change_flag_custorder,
      //   order_memo:order_memo_custorder,
      //   update_date
      // } = cuEstimate
      
      // console.log(cuEstimate)

      this.setState({
        data:{
          ...this.props.data,
          values:{
            ...this.props.data.values,
            old_quote_available_start_date : this.props.data.values.survey_available_start_date,
            old_quote_available_end_date : this.props.data.values.survey_available_end_date,
            old_quote_capacity_qty : this.props.data.values.survey_capacity_qty,
            estimate_change_flag: this.props.data.values.estimate_change_flag,
            quote_available_start_date : this.props.data.values.order_start_date == null ? this.props.data.values.survey_available_start_date :this.props.data.values.order_start_date ,
            quote_available_end_date : this.props.data.values.order_end_date== null ?  this.props.data.values.survey_available_end_date:this.props.data.values.order_end_date ,
            quote_capacity_qty : this.props.data.values.order_capacity_qty== null ?  this.props.data.values.survey_capacity_qty:this.props.data.values.order_capacity_qty ,
            order_contact_memo: this.props.data.values.order_contact_memo,
            non_taxable_flag : cst_non_taxable_flag[0].default, 
            quote_term_month_flag : this.props.data.values.survey_term_month_flag,
            quote_cost_total_amt : request_type == 3 ? this.props.data.values.survey_cost_total_amt : undefined,
            quote_subtotal_amt : (request_type == 3 && survey_tax_in_flag == 0) ? this.props.data.values.survey_subtotal_amt : undefined,
            quote_total_amt : (request_type == 3 && survey_tax_in_flag == 1) ? this.props.data.values.survey_total_amt : undefined
          },
          errors:{},
          requiredData:{
            latest_pdf_supplier_invoice_url:[GetMessage(2024)],
            quote_available_start_date:[GetMessage(2024)],
            quote_available_end_date:[GetMessage(2024)],
            quote_capacity_qty:[GetMessage(2024)],
            quote_cost_total_amt:[GetMessage(2024)],
            quote_subtotal_amt:[GetMessage(2024)],
            quote_total_amt:[GetMessage(2024)],
          }
        }
      })
    }

    const prevStateData = prevState.data.values
    const {
      quote_available_start_date,
      quote_available_end_date,
      quote_term_month_flag,
      survey_cost_parking_rent,
      quote_capacity_qty,
      survey_cost_key_money,
      survey_cost_commission,
      survey_parking_rent,
      survey_key_money,
      survey_discount_amt,
      survey_adjustment_amt,
      survey_fraction_amt_flag,
      survey_tax_in_flag,
      survey_commission_discount_amt,
      customer_branch_natural_id,
      customer_natural_id,
      request_type,
      survey_cost_security_deposit,
      survey_term_month_flag,
      survey_cost_other,
    } = this.state.data.values
    let { 
      quote_cost_total_amt,
      quote_subtotal_amt,
      quote_total_amt 
    } = this.state.data.values;

    if (
      (quote_available_start_date!=prevStateData.quote_available_start_date)||
      (quote_available_end_date!=prevStateData.quote_available_end_date) ||
      (quote_term_month_flag!=prevStateData.quote_term_month_flag) ||
      (quote_capacity_qty!=prevStateData.quote_capacity_qty) ||
      (quote_cost_total_amt!=prevStateData.quote_cost_total_amt) ||
      (quote_subtotal_amt!=prevStateData.quote_subtotal_amt) ||
      (quote_total_amt!=prevStateData.quote_total_amt) 
    ){
      // const survey_cost_parking_rent = this.getNumberForCalculation(raw_survey_cost_parking_rent)
      const endDate = new Date(quote_available_end_date)
      const startDate = new Date(quote_available_start_date)
      
      const {
        monthCount,
        days,
        startDays,
        endDays
      } = await this.getCountsFromDuration(startDate, endDate, quote_term_month_flag)
      const hasFullLastMonth = days==0
      const quote_month_qty = this.getNumberForCalculation(monthCount)
      const quote_day_qty = (!hasFullLastMonth&&days>0 ? this.getNumberForCalculation(days) : 0)
      
      
      const firstDay = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
      const lastDay = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
      
      if(request_type != 3){
         quote_cost_total_amt = //(request_type==3) ? 0 : 
        ( survey_cost_parking_rent * quote_month_qty * quote_capacity_qty + parseInt(survey_cost_parking_rent / 30) * quote_day_qty * quote_capacity_qty + survey_cost_commission * quote_capacity_qty + survey_cost_key_money * quote_capacity_qty + survey_cost_other)  
      }

      const quote_cost_security_deposit_total_amt = survey_cost_security_deposit * quote_capacity_qty

      const summed_quote_subtotal_amt = 
         survey_parking_rent * quote_month_qty * quote_capacity_qty
          + parseInt(survey_parking_rent / 30) * quote_day_qty * quote_capacity_qty
          + survey_commission_discount_amt * quote_capacity_qty
          + survey_key_money * quote_capacity_qty
          + survey_discount_amt + this.getNumberForCalculation(survey_adjustment_amt)
//      console.log('summed_quote_subtotal_amt', summed_quote_subtotal_amt)
      
      if(request_type != 3){
        quote_subtotal_amt = survey_fraction_amt_flag == "1" 
        ? parseInt(summed_quote_subtotal_amt/100)*100 
        : summed_quote_subtotal_amt
//      console.log('quote_subtotal_amt', quote_subtotal_amt)
      }

      const quote_tax_amt = (survey_tax_in_flag == "1")
        ? 0
        : parseInt(quote_subtotal_amt * 0.1)

      if(!(request_type == 3 && survey_tax_in_flag == "1")){
        quote_total_amt = (survey_tax_in_flag == "1")
          ? quote_subtotal_amt
          : parseInt(quote_subtotal_amt * 1.1)
      }

      const _CAL_profit_amt = quote_total_amt - quote_cost_total_amt
      const _CAL_profit_rate = this.getNumberForCalculation(_CAL_profit_amt / quote_total_amt * 10000)/100

      const totalCountForDetails = (startDays?1:0)+(endDays?1:0)+monthCount
      // const incrementalMonthCount = totalCountForDetails>11?2:1
      const incrementalMonthCount = Math.ceil(totalCountForDetails/11)
      
      let estimate_details = []
      if (request_type == 3){
        // 積替の場合、明細行を１行にする。
        estimate_details.push(
          {
            estimate_detail_name: `${Format.dateToString(startDate, 'YYYY年M月分賃料')} (${Format.dateToString(startDate, 'M月D日')} ～ ${Format.dateToString(endDate, 'M月D日')})`,
            estimate_detail_qty: quote_capacity_qty,
            estimate_detail_unit_cost: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
            estimate_detail_term: null,
            estimate_detail_term_type: null,
            estimate_detail_amt: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
            estimate_type: 1
          }
        )
      } else {
        const startDays_start = startDate;
        const startDays_end =  (startDays_start.getFullYear() === endDate.getFullYear() && startDays_start.getMonth() === endDate.getMonth()) ? endDate : new Date(startDays_start.getFullYear(), startDays_start.getMonth() + 1 , 0)
        startDays && (estimate_details.push(
          {
            estimate_detail_name: `${Format.dateToString(startDays_start, 'YYYY年M月分賃料')} (${Format.dateToString(startDays_start, 'M月D日')} ～ ${Format.dateToString(startDays_end, 'M月D日')})`,
            estimate_detail_qty: quote_capacity_qty,
            estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
            estimate_detail_term: `${startDays}`,
            estimate_detail_term_type:'日',
            estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
            estimate_type: 1
          }
        ))
        if(Number(quote_term_month_flag) == 0){
          for (let i = 0; i<monthCount; i+=incrementalMonthCount){
            // const addMonth = (monthCount-incrementalMonthCount<i && monthCount%2!=0) ? 1 : incrementalMonthCount
            const addMonth = (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount
            const calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 1)
            const calculatedMonth_end = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth+(startDays?1:0), 0)
            let estimate_detail_name = ''
            if(incrementalMonthCount === 1){
              estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
            } else {
              if(calculatedMonth_start.getMonth() === calculatedMonth_end.getMonth()){
                estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
              } else {
                estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月')}・${(calculatedMonth_start.getFullYear() !== calculatedMonth_end.getFullYear() ? Format.dateToString(calculatedMonth_end, 'YYYY年') : '')}${Format.dateToString(calculatedMonth_end, 'M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
              }
            }
            estimate_details.push({
              estimate_detail_name: estimate_detail_name,
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: survey_parking_rent,
              estimate_detail_term: (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount,
              estimate_detail_term_type:'月',
              estimate_detail_amt: survey_parking_rent * quote_capacity_qty * ((monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount),
              estimate_type: 1
            })
          }
        } else if (Number(quote_term_month_flag) == 1) {
          for (let i = 0; i<monthCount; i+=incrementalMonthCount){
            
            // const addMonth = (monthCount-incrementalMonthCount<i && monthCount%2!=0) ? 1 : incrementalMonthCount
            const addMonth = (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount
            const calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
            const calculatedMonth_end = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth, (startDate.getDate() === 1 ? 0 : endDate.getDate()))
  
            let estimate_detail_name = ''
            if(incrementalMonthCount === 1){
              estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
            } else {
              if(calculatedMonth_start.getMonth() === calculatedMonth_end.getMonth()){
                estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
              } else {
                estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月')}・${(calculatedMonth_start.getFullYear() !== calculatedMonth_end.getFullYear() ? Format.dateToString(calculatedMonth_end, 'YYYY年') : '')}${Format.dateToString(calculatedMonth_end, 'M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
              }
            }
            estimate_details.push({
              estimate_detail_name: estimate_detail_name,
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: survey_parking_rent,
              estimate_detail_term: (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount,
              estimate_detail_term_type:'月',
              estimate_detail_amt: survey_parking_rent * quote_capacity_qty * ((monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount !=0) ? monthCount%incrementalMonthCount : incrementalMonthCount),
              estimate_type: 1
            })
          }
        } else {
          console.error('quote_term_month_flag が 0 または 1 ではありません:', quote_term_month_flag)
					this.props.alertModal.current.confirmCheck({
						messageNo: 2428,
						closeBtn: false
					}, ()=>{
						// this.props.refreshCallback()
						window.location.reload()
					})
        }
        const endDays_start = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        const endDays_end =  endDate;
        endDays && (estimate_details.push({
          estimate_detail_name: `${Format.dateToString(endDays_start, 'YYYY年M月分賃料')} (${Format.dateToString(endDays_start, 'M月D日')} ～ ${Format.dateToString(endDays_end, 'M月D日')})`,
          estimate_detail_qty: quote_capacity_qty,
          estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
          estimate_detail_term: `${endDays}`,
          estimate_detail_term_type:'日',
          estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
          estimate_type: 1
        }))
      }

      // 独自帳票 
      // 三井ホーム　株式会社 -> 東北支店リフォーム営業室 : customer_natural_id 6 customer_branch_natural_id 6024
      // 三井ホーム　株式会社 -> 埼玉支店 : customer_natural_id 6 customer_branch_natural_id 6, 6017, 6018, 6025, 6026
      // 三井ホーム　株式会社 -> その他 : customer_natural_id 6
      // 住友不動産　株式会社 : customer_natural_id 119
      const customEstimateDetails = this.createCustomEstimateDetails({
        customer_natural_id,
        customer_branch_natural_id,
        survey_parking_rent,
        quote_capacity_qty,
        quote_subtotal_amt,
        incrementalMonthCount,
        startDate,
        endDate,
        monthCount,
        startDays,
        endDays,
        request_type,
        survey_tax_in_flag,
        quote_total_amt
      })

//      console.log('estimate_details ', estimate_details)
//      console.log('customEstimateDetails ', customEstimateDetails)

      estimate_details = [
        ...estimate_details,
        ...customEstimateDetails
      ]

      const alert = Number(quote_term_month_flag) == 0?
      (
        //通し無
        (
          (endDate.getTime() != lastDay.getTime())
        ) ? {
          quote_term_month_flag:[GetMessage(2425), {notIgnore:false}],
        } : ( hasFullLastMonth
          ? {
            quote_term_month_flag:[GetMessage(2426), {notIgnore:false}],
          }
          : {
            quote_term_month_flag:undefined,
          }
          )
      ):Number(quote_term_month_flag) == 1 ? (
        //通し有
        !hasFullLastMonth?{
          quote_term_month_flag:[GetMessage(2427),{notIgnore:true}],
        }:{
          quote_term_month_flag:undefined,
        }
      ) : (
        console.error('quote_term_month_flag が 0 または 1 ではありません:', quote_term_month_flag),
        { quote_term_month_flag: [GetMessage(2428),{notIgnore:true}],}
      )

      this.setState({
        data:{
          ...this.state.data,
          values:{
            ...this.state.data.values,
            quote_month_qty,
            quote_day_qty,
            quote_cost_total_amt,
            quote_subtotal_amt,
            quote_tax_amt,
            quote_total_amt,
            quote_cost_security_deposit_total_amt,
            _CAL_profit_amt,
            _CAL_profit_rate,
            estimate_details
          },
          errors:{
            ...this.state.data.errors,
            ...alert,
            ...{_CAL_profit_amt:_CAL_profit_amt<0?[GetMessage(2430), {notIgnore:false}]:undefined},
            latest_pdf_supplier_invoice_url : !this.state.data.values.latest_pdf_supplier_invoice_url ? [GetMessage(2024)] : undefined
          }
        }
      })
    }
  }

  createCustomEstimateDetails(estimateDataWithDays){
    const {
      customer_natural_id,
      customer_branch_natural_id,
      quote_capacity_qty,
      survey_parking_rent,
      quote_subtotal_amt,
      incrementalMonthCount,
      startDate,
      endDate,
      monthCount,
      startDays,
      endDays,
      request_type,
      survey_tax_in_flag,
      quote_total_amt
    } = estimateDataWithDays
    let estimate_details = []
    const customReportCustomerObject = custom_report.estimate.quote
    switch(customer_natural_id){
      case customReportCustomerObject["三井ホーム"].customer_natural_id:
        if (customReportCustomerObject["三井ホーム"]["東北支店リフォーム営業室"].customer_branch_natural_id.includes(customer_branch_natural_id)) {
          // 三井ホーム　株式会社 -> 東北支店リフォーム営業室 : 6024

          // 積替の場合
          if (request_type == 3){
            estimate_details.push(
              {
                estimate_detail_name: `駐車場代（${Format.dateToString(startDate, 'JY/M/D')}～${Format.dateToString(endDate, 'JY/M/D')})`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
                estimate_detail_term: null,
                estimate_detail_term_type: null,
                estimate_detail_amt: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
                estimate_type: 2
              }
            )
          } else {
            estimate_details.push(
              {
                estimate_detail_name: `駐車場代（${Format.dateToString(startDate, 'JY/M/D')}～${Format.dateToString(endDate, 'JY/M/D')})`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: parseInt(quote_subtotal_amt / quote_capacity_qty),
                estimate_detail_term: null,
                estimate_detail_term_type: null,
                estimate_detail_amt: quote_subtotal_amt,
                estimate_type: 2
              }
            )
          }
          return estimate_details
        } else if (customReportCustomerObject["三井ホーム"]["埼玉支店"].customer_branch_natural_id.includes(customer_branch_natural_id)) {
          // 三井ホーム -> 埼玉支店 : 6, 6017, 6018, 6025, 6026
          if (request_type == 3){
            //  三井ホーム -> 埼玉支店（積替）の場合、明細行を１行にする。
            estimate_details.push(
              {
                estimate_detail_name: `駐車場代（${Format.dateToString(startDate, 'JJ年M月')}分賃料（${Format.dateToString(startDate, 'M/D')}～${Format.dateToString(endDate, 'M/D')}分））`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
                estimate_detail_term: null,
                estimate_detail_term_type: null,
                estimate_detail_amt: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
                estimate_type: 2
              }
            )
            return estimate_details
          } else {
            startDays && (estimate_details.push(
              {
                estimate_detail_name: `駐車場代（${Format.dateToString(startDate, 'JJ年M月')}分賃料（${Format.dateToString(startDate, 'M/D')}～${Format.dateToString(new Date(startDate.getFullYear(),startDate.getMonth()+1,0), 'M/D')}分日割り））`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
                estimate_detail_term: `${startDays}`,
                estimate_detail_term_type:'日',
                estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
                estimate_type: 2
              }
            ))
            for (let i = 1; i<=monthCount; i+=1){
              const calculatedMonth = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 0)
              estimate_details.push({
                estimate_detail_name: `駐車場代（${Format.dateToString(calculatedMonth, 'JJ年M月')}分賃料）`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: survey_parking_rent,
                estimate_detail_term: 1,
                estimate_detail_term_type:'月',
                estimate_detail_amt: survey_parking_rent * quote_capacity_qty,
                estimate_type: 2
              })
            }
            endDays && (estimate_details.push({
              estimate_detail_name: `駐車場代（${Format.dateToString(endDate, 'JJ年M月')}分賃料（${Format.dateToString(new Date(endDate.getFullYear(),endDate.getMonth(),1), 'M/D')}～${Format.dateToString(endDate, 'M/D')}分日割り））`,
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
              estimate_detail_term: `${endDays}`,
              estimate_detail_term_type:'日',
              estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
              estimate_type: 2
            }))
            return estimate_details
          }
        } else {
          // 三井ホーム　株式会社 -> その他
          // 積替の場合
          if (request_type == 3){
            estimate_details.push(
              {
                estimate_detail_name: `駐車場代（${Format.dateToString(startDate, 'JY/M/D')}～${Format.dateToString(endDate, 'JY/M/D')})`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
                estimate_detail_term: null,
                estimate_detail_term_type: null,
                estimate_detail_amt: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
                estimate_type: 2
              }
            )
          } else {
            estimate_details.push(
              {
                estimate_detail_name: `駐車場代（${Format.dateToString(startDate, 'JY/M/D')}～${Format.dateToString(endDate, 'JY/M/D')})`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: parseInt(quote_subtotal_amt / quote_capacity_qty),
                estimate_detail_term: null,
                estimate_detail_term_type: null,
                estimate_detail_amt: quote_subtotal_amt,
                estimate_type: 2
              }
            )
          }
          return estimate_details
        }
      case customReportCustomerObject["住友不動産"].customer_natural_id:
        // 住友不動産　株式会社
        if (request_type == 3){
          //  住友不動産　株式会社（積替）の場合、明細行を１行にする。
          estimate_details.push(
            {
              estimate_detail_name: `${Format.dateToString(startDate, 'M/D')}～${Format.dateToString(endDate, 'M/D')}分賃料等`,
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
              estimate_detail_term: null,
              estimate_detail_term_type: null,
              estimate_detail_amt: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
              estimate_type: 2
            }
          )
          return estimate_details
        } else {
          const rowCount = (startDays?1:0)+(endDays?1:0)+monthCount
          if (rowCount>4){
            startDays && (estimate_details.push(
              {
                estimate_detail_name: `${Format.dateToString(startDate, 'M/D')}～${Format.dateToString(new Date(startDate.getFullYear(),startDate.getMonth()+1,0), 'M/D')}分賃料等`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
                estimate_detail_term: `${startDays}`,
                estimate_detail_term_type:'日',
                estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
                estimate_type: 2
              }
            ))
            monthCount && (estimate_details.push({
              estimate_detail_name: `${Format.dateToString(new Date(startDate.getFullYear(), startDate.getMonth()+(startDays?1:0), 1), 'M/D')}～${Format.dateToString(new Date(startDate.getFullYear(), startDate.getMonth()+monthCount+(startDays?1:0), 0), 'M/D')}分賃料等`,
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: survey_parking_rent,
              estimate_detail_term: monthCount,
              estimate_detail_term_type:'月',
              estimate_detail_amt: survey_parking_rent * quote_capacity_qty * monthCount,
              estimate_type: 2
            }))
            endDays && (estimate_details.push({
              estimate_detail_name: `${Format.dateToString(new Date(endDate.getFullYear(),endDate.getMonth(),1), 'M/D')}～${Format.dateToString(endDate, 'M/D')}分賃料等`,
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
              estimate_detail_term: `${endDays}`,
              estimate_detail_term_type:'日',
              estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
              estimate_type: 2
            }))
            return estimate_details
          } else {
            startDays && (estimate_details.push(
              {
                estimate_detail_name: `${Format.dateToString(startDate, 'M/D')}～${Format.dateToString(new Date(startDate.getFullYear(),startDate.getMonth()+1,0), 'M/D')}分賃料等`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
                estimate_detail_term: `${startDays}`,
                estimate_detail_term_type:'日',
                estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
                estimate_type: 2
              }
            ))
            for (let i = 1; i<=monthCount; i+=1){
              const calculatedMonth = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 0)
              estimate_details.push({
                estimate_detail_name: `${Format.dateToString(new Date(calculatedMonth.getFullYear(),calculatedMonth.getMonth(),1), 'M/D')}～${Format.dateToString(new Date(calculatedMonth.getFullYear(),calculatedMonth.getMonth()+1,0), 'M/D')}分賃料等`,
                estimate_detail_qty: quote_capacity_qty,
                estimate_detail_unit_cost: survey_parking_rent,
                estimate_detail_term: 1,
                estimate_detail_term_type:'月',
                estimate_detail_amt: survey_parking_rent * quote_capacity_qty,
                estimate_type: 2
              })
            }
            endDays && (estimate_details.push({
              estimate_detail_name: `${Format.dateToString(new Date(endDate.getFullYear(),endDate.getMonth(),1), 'M/D')}～${Format.dateToString(endDate, 'M/D')}分賃料等`,
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
              estimate_detail_term: `${endDays}`,
              estimate_detail_term_type:'日',
              estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
              estimate_type: 2
            }))
            return estimate_details
          }
        }
      default:
        if(request_type == 3){
          // 積替の場合、明細行を１行にする。
          estimate_details.push(
            {
              estimate_detail_name: `${Format.dateToString(startDate, 'YYYY年M月分賃料')} (${Format.dateToString(startDate, 'M月D日')} ～ ${Format.dateToString(endDate, 'M月D日')})`,
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
              estimate_detail_term: null,
              estimate_detail_term_type: null,
              estimate_detail_amt: survey_tax_in_flag == 0 ? quote_subtotal_amt : quote_total_amt,
              estimate_type: 2
            }
          )
          return estimate_details;
        } else {
          startDays && (estimate_details.push(
            {
              estimate_detail_name: `${Format.dateToString(startDate, 'YYYY年M月分賃料')}(${startDays}日)`,
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
              estimate_detail_term: `${startDays}`,
              estimate_detail_term_type:'日',
              estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
              estimate_type: 2
            }
          ))
          for (let i = 1; i<=monthCount; i+=incrementalMonthCount){
            const calculatedMonth = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 0)
            estimate_details.push({
              estimate_detail_name: Format.dateToString(calculatedMonth, 'YYYY年M月分賃料'),
              estimate_detail_qty: quote_capacity_qty,
              estimate_detail_unit_cost: survey_parking_rent,
              estimate_detail_term: (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount,
              estimate_detail_term_type:'月',
              estimate_detail_amt: survey_parking_rent * quote_capacity_qty * ((monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount),
              estimate_type: 2
            })
          }
          endDays && (estimate_details.push({
            estimate_detail_name: `${Format.dateToString(endDate, 'YYYY年M月分賃料')}(${endDays}日)`,
            estimate_detail_qty: quote_capacity_qty,
            estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
            estimate_detail_term: `${endDays}`,
            estimate_detail_term_type:'日',
            estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
            estimate_type: 2
          }))
          return estimate_details
        }
    }
    
  }

  getCountsFromDuration(startDate, endDate, quote_term_month_flag){
    return new Promise(async resolve=>{

      startDate.setHours(0)
      endDate.setHours(0)

      if (Number(quote_term_month_flag)==0){
        const startMonthEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1)
        const endDateIsLast = (endDate.getTime() == (new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0)).getTime())
        const startDays = await (()=>{
          if (startMonthEndDate>endDate && !endDateIsLast){
            return ((endDate - startDate) /1000/60/60/24) + 1
          }else if ( startDate.getDate()=="1"){
            return 0
          } else {
            return ((startMonthEndDate - startDate) /1000/60/60/24)
          }
        })()
        const startDateOfEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), 0)
        const endDays = (endDateIsLast || (startDate.getFullYear() == endDate.getFullYear() && startDate.getMonth()==endDate.getMonth()))
          ? 0
          : ((endDate-startDateOfEndDate)/1000/60/60/24)
        let monthCount = 0
        while ( new Date(startDate.getFullYear(), startDate.getMonth() + 1 + monthCount, 1) < new Date(endDate.getFullYear(), endDate.getMonth() + 1, 1) ){
          monthCount += 1
        }

        const days = startDays + endDays

        endDateIsLast && (startDays==0&&endDays==0) && monthCount++;

        (startDays!==0&&endDays!==0) && monthCount--;


        resolve({
          monthCount:monthCount<0?0:monthCount,
          days:parseInt(days),
          startDays:parseInt(startDays),
          endDays:parseInt(endDays)
        })
      } else if (Number(quote_term_month_flag)==1) {
        let monthCount = 0
        while ( new Date(startDate.getFullYear(), startDate.getMonth() + monthCount, (startDate.getDate()-1) ) < endDate ){
          monthCount += 1
        }
        const days = (endDate - new Date(startDate.getFullYear(), startDate.getMonth() + monthCount, (startDate.getDate()-1) ) ) /1000/60/60/24
        resolve({
          monthCount,
          days:parseInt(days),
        })
      } else {
        console.error('quote_term_month_flag が 0 または 1 ではありません:', quote_term_month_flag)
        this.props.alertModal.current.confirmCheck({
          messageNo: 2428,
          closeBtn: false
        }, ()=>{
          // this.props.refreshCallback()
          window.location.reload()
        })
      }
    })
  }

  getNumberForCalculation(number){
    return isNaN(parseInt(number)) ? 0 : parseInt(number)
  }

  validateCallback(newData, callback=()=>{}){
    if(this.alertDateCheck(newData.values)){
      let tmpData = newData
      tmpData.errors.quote_capacity_qty = newData.values.quote_capacity_qty == 0 || newData.values.quote_capacity_qty == null ? [GetMessage(2024)] : null
      this.setState({
        data:{
          ...this.state.data,
          ...tmpData
        },
      }, ()=>callback())
    }
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors, this.state.data.values.ignore_error)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  alertDateCheck({
    quote_available_start_date,
    quote_available_end_date
  }){
    const {
      quote_available_start_date:prev_quote_available_start_date,
    } = this.state.data.values
    if(quote_available_start_date && quote_available_end_date){
      if(moment(quote_available_start_date) > moment(quote_available_end_date)){
        this.setState({
          data:{
            ...this.state.data,
            errors:{
              ...this.state.data.errors,
              ...{[(prev_quote_available_start_date === quote_available_start_date ? 'quote_available_end_date' : 'quote_available_start_date')]:[GetMessage(2462)]},
            }
          }
        })
        return false
      }
    }
    return true
  }

  handleClickNegative(){
    //いいえを押した場合、入力値初期化
    this.setState({
      data:{
        ...this.props.data,
        values:{
          ...this.props.data.values,
          quote_available_start_date : null,
          quote_available_end_date : null,
          quote_capacity_qty : null,
          non_taxable_flag : null, 
          quote_term_month_flag : null,
        }
      }
    })
    this.toggleModal();
  }

  async handleClickPositive(){
    //API estimatelist/mail/:ulid
    if (!this.validate()){
      return;
    }

    Request.setProgress(80)
    
    const params = {
      ...this.state.data.values,
      estimate_status:'4',
    }
    const resultCode = await new Promise((resolve, reject)=>{
        Request.put('/api/order/status/' + this.state.data.values.ulid, params, async (res)=>{
          resolve(res.Code)
      },(err)=>{
        Request.setProgress(0)
        // reject(err)
      })
    })
    
    Request.setProgress(90)
    if (resultCode == 200){

      Request.setProgress(0)

      this.props.alertModal.current.confirmCheck({
        title: "処理完了",
        messageNo: [2417],
        closeBtn: false
      }, ()=>{
        // 初期化処理
        this.setState({
          data:{
            ...this.props.data,
            values:{
              ...this.props.data.values,
              quote_available_start_date : null,
              quote_available_end_date : null,
              quote_capacity_qty : null,
              non_taxable_flag : null, 
              quote_term_month_flag : null,
            }
          }
        })
        this.props.refreshCallback()
        this.toggleModal();
      }, false)
    }
    Request.setProgress(0)
   
  }

  bodyContent() {
//    console.log('dialog state', this.state)
    return (
      <>
        <Row>
          <Col md="4">
          見積ID：{this.state.data.values.estimate_natural_id}<br />
          駐車場：{this.state.data.values.survey_parking_name}
          </Col>
          <Col md="4">
          現場名：{this.state.data.values.site_name}
          </Col>
          <Col md="4">
          <InputText
            label='契約区画番号'
            labelOn={true}
            name='ESTIMATE__quote_plotting_number'
            validateCallback={this.validateCallback}
            rootData={this.state.data}
            validateType="regist"
          />
        </Col>          
        </Row>
        <Row>
        <Col md="3">
          契約開始日:{Format.format_date_en(this.state.data.values.old_quote_available_start_date)}
          <InputDatetime
            label='契約開始日'
            labelOn={false}
            name='ESTIMATE__quote_available_start_date'
            rootData={this.state.data}
            validateCallback={this.validateCallback}
            validateType="regist"
            // disabled={this.state.data.values.request_type=="2"}
          />
        </Col>
        <Col md="3">
          契約終了日:{Format.format_date_en(this.state.data.values.old_quote_available_end_date)}
          <InputDatetime
            label='契約終了日'
            labelOn={false}
            name='ESTIMATE__quote_available_end_date'
            rootData={this.state.data}
            validateCallback={this.validateCallback}
            validateType="regist"
            // disabled={this.state.data.values.request_type=="2"}
          />
        </Col>
        <Col md="3">
        台数:{this.state.data.values.old_quote_capacity_qty}台
          <InputNumber
            unit='台'
            label='台数'
            labelOn={false}
            name='ESTIMATE__quote_capacity_qty'
            validateCallback={this.validateCallback}
            rootData={this.state.data}
            validateType="regist"
            size={12}
            // disabled={this.state.data.values.request_type=="2"}
          />
        </Col>
        {(this.state.data.values.estimate_change_flag == "1" &&<Col md="12" style={{color:'red'}}>
        顧客より受注内容変更の要望があります
        </Col>)}
        </Row>
        <Row>
          <Col md="12">
          <InputText multiline={true}
            labelOn={true}
            label='顧客からの連絡事項'
            name='ESTIMATE__order_contact_memo'
            validateCallback={this.validateCallback} 
            rootData={this.state.data}
            validateType='regist'
            disabled={true}
            placeholder=" "
          />
          </Col>
        </Row>        

        <Row style={{marginTop: "30px"}}>
          <Col md="12">仕入先からの請求書</Col>
        </Row>
        <Row>
          <Col>
          <InputFile
            label='ファイル選択'
            name='ESTIMATE__latest_pdf_supplier_invoice_url'
            validateCallback={this.validateCallback}
            rootData={this.state.data}
            validateType="regist"
          />
          </Col>
        </Row>

        <Row>
        <Col md="3">
          <InputRadio options={cst_non_taxable_flag}
            validateCallback={this.validateCallback} 
            rootData={this.state.data}
            labelOn={true}
            validateType="regist"
            label="非課税対象"
            name="ESTIMATE__non_taxable_flag"
            />
        </Col>
        <Col md="3">
          <InputRadio
            options={cst_term_month_flag}
            validateCallback={this.validateCallback} 
            validateType='regist'
            labelOn={true}
            rootData={this.state.data}
            label='通し有無'
            name='ESTIMATE__quote_term_month_flag'
            disabled={this.state.data.values.request_type=="3"}
          />
        </Col>
        <Col md="3">
          <InputNumber
            unit='ヶ月'
            label='実質月数'
            labelOn={true}
            disabled={true}
            name='ESTIMATE__quote_month_qty'
            value={(this.state.data.errors.quote_term_month_flag&&this.state.data.errors.quote_term_month_flag[1].notIgnore)?"":this.state.data.values.quote_month_qty}
            validateType="regist"
            size={12}
          />
        </Col>
        <Col md="3">
          <InputNumber
            label='実質日数'
            labelOn={true}
            name='ESTIMATE__quote_day_qty'
            value={(this.state.data.errors.quote_term_month_flag&&this.state.data.errors.quote_term_month_flag[1].notIgnore)?"":this.state.data.values.quote_day_qty}
            disabled={true}
            validateType="regist"
            size={12}
          />
        </Col>
        </Row>
        <Row>
        <Col md="3">
          <InputNumber
            unit='円'
            label='仕入合計'
            labelOn={true}
            name='ESTIMATE__quote_cost_total_amt'
            validateCallback={this.validateCallback}
            disabled={this.state.data.values.request_type!=3}
            {
              ...(this.state.data.values.request_type!=3
              ? {value:Format.comma_delimited(this.state.data.values.quote_cost_total_amt)}
              : {rootData:this.state.data})
            }
            validateType="regist"
            size={12}
          />
        </Col>
        </Row>
        <Row>
        <Col md="3">
          <InputNumber
            unit='円'
            label='見積小計'
            labelOn={true}
            name='ESTIMATE__quote_subtotal_amt'
            validateCallback={this.validateCallback}
            disabled={!(this.state.data.values.request_type==3&&this.state.data.values.survey_tax_in_flag=="0")}
            {
              ...((!(this.state.data.values.request_type==3&&this.state.data.values.survey_tax_in_flag=="0"))
              ? {value:Format.comma_delimited(this.state.data.values.quote_subtotal_amt)}
              : {rootData:this.state.data})
            }
            validateType="regist"
            size={12}
          />
        </Col>
        <Col md="3">
          <InputRadio
            options={cst_tax_in_flag}
            validateCallback={this.validateCallback} 
            validateType='regist'
            labelOn={true}
            rootData={this.state.data}
            disabled={true}
            label='税込フラグ'
            name='ESTIMATE__survey_tax_in_flag'
          />
        </Col>
        <Col md="3">
          <InputNumber
            unit='円'
            label='税額'
            labelOn={true}
            name='ESTIMATE__quote_tax_amt'
            validateCallback={this.validateCallback}
            disabled={true}
            value={Format.comma_delimited(this.state.data.values.quote_tax_amt)}
            validateType="regist"
            size={12}
          />
        </Col>
        <Col md="3">
          <InputNumber
            unit='円'
            label='見積合計'
            labelOn={true}
            name='ESTIMATE__quote_total_amt'
            validateCallback={this.validateCallback}
            disabled={!(this.state.data.values.request_type==3&&this.state.data.values.survey_tax_in_flag=="1")}
            {
              ...((!(this.state.data.values.request_type==3&&this.state.data.values.survey_tax_in_flag=="1"))
              ? {value:Format.comma_delimited(this.state.data.values.quote_total_amt)}
              : {rootData:this.state.data})
            }
            validateType="regist"
            size={12}
          />
        </Col>
        </Row>
        <Row>
        <Col md="3">
          <InputNumber
            unit='円'
            label='利益額 '
            labelOn={true}
            name='___CAL_profit_amt'
            validateCallback={this.validateCallback}
            disabled={true}
            value={Format.comma_delimited(this.state.data.values._CAL_profit_amt)}
            size={12}
          />
        </Col>
        <Col md="3">
          <InputNumber
            unit='%'
            label='利益率 '
            labelOn={true}
            name='___CAL_profit_rate'
            validateCallback={this.validateCallback}
            rootData={this.state.data}
            disabled={true}
            size={12}
          />
        </Col>
          <Col md="3">
            <InputCheckBox 
              label="エラーを無視する"
              name="TEMP__ignore_error" 
              validateCallback={this.validateCallback} 
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.data}
              />
          </Col>
        </Row>
        <Row>
        <Col md="12">
          <InputText multiline={true}
            labelOn={true}
            label='受注管理メモ'
            name='ESTIMATE__order_memo'
            validateCallback={this.validateCallback} 
            rootData={this.state.data}
            validateType='regist'
          />
        </Col>
        </Row>
        </>
    );
  }
}

class DialogConfirm extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '失注処理を実行します。よろしいですか？',
      data:this.props.data
    });
    this.validateCallback = this.validateCallback.bind(this)
    this.updateMemo = this.updateMemo.bind(this);
  }

  componentDidUpdate(prevProps){
    if(prevProps.data!=this.props.data){
      this.setState({
        data:this.props.data
      })
    }
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      data:{
        ...this.state.data,
        ...newData
      }
    }, ()=>callback())
  }

  updateMemo(data) {
    //API estimatelist/status/:ulid
    if (Object.keys(this.state.data.errors).length>0){
      return
    }

    let current_memo = this.state.data.values.order_memo;         
    current_memo = current_memo === null ? "" : current_memo
    const memo = data.add_memo ? data.add_memo : ""

    // 無効な文字列
    const max_length_validate = Validate.length(current_memo + memo, "", "text_ja_20000")
    if(!max_length_validate.valid){
      this.props.alertModal.current.showErrorModal({message:max_length_validate.message});
      return;
    }

    const params = {
      ...this.state.data.values,
      estimate_status:'6',
      add_memo: data.add_memo,
      login_user: localStorage.getItem("name")
    }
    Request.put('/api/order/status/' + this.state.data.values.ulid, params,()=>{
      this.props.refreshCallback();
    })
  }

  bodyContent() {
    const rootData = {
      ...this.state,
      data : {
        ...this.state.data,
        isOrderMemo : true,
        label : "顧客メモ"
      },
      updateMemo: this.updateMemo
    }

    return (
      <AddMemoPopupInner
        rootData={rootData}
        alertModal={this.props.alertModal}
        toggleModal={this.toggleModal}
        positiveButtonName="はい"
        negativeButtonName="いいえ"
        unnecessaryCloseCrossButton={true}
        allowEmptyComment={true}
      />
    );
  }
}

export class DialogCalcelConfirm extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '見積キャンセルを確認済にします。よろしいですか？',
      data : this.props.data,
    });
  }

  componentDidUpdate(prevProps){
    if(JSON.stringify(this.props) === JSON.stringify(prevProps))
      return;

    this.setState({
      data:this.props.data
    })
  }

  handleClickPositive() {
    const { values } = this.state.data;
    const cancelParams = {
      ...values,
      estimate_cancel_check_flag : 1,
      estimate_cancel_check_date : moment().format("YYYY-MM-DDTHH:mm:ss")
    }
    Request.put('/api/order/status/' + this.state.data.values.ulid, cancelParams,()=>{
      this.props.refreshCallback();
      this.toggleModal();
    })
  }

  handleClickNegative(){
    this.toggleModal();
  }

  bodyContent(){
    return(<></>);
  }
}

export class DialogReturnEstimate extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '見積前に戻します。よろしいですか？',
      data : this.props.data,
    });
  }

  componentDidUpdate(prevProps){
    if(JSON.stringify(this.props) === JSON.stringify(prevProps))
      return;

    this.setState({
      data:this.props.data
    })
  }

  handleClickPositive() {
    const { values } = this.state.data;
    const params = {
      ...values,
      survey_status : 0,
    }
    Request.put('/api/order/status/' + this.state.data.values.ulid, params,()=>{
      this.props.refreshCallback();
      this.toggleModal();
    })
  }

  handleClickNegative(){
    this.toggleModal();
  }

  bodyContent(){
    return(<></>);
  }
}
export default List;
